// extracted by mini-css-extract-plugin
export var root = "AnnouncementBar-module--root--q8njZ";